import { useEffect, useState , Fragment,useRef} from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import Moment from "moment";
import * as moment from 'moment';
import SignatureCanvas from "react-signature-canvas";


const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    iDEnvia: "",
    direccionEnvia: "",
    sectorEnvia: "",
    puebloEnvia: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    iDRecibe: "",
    nombreRecibe: "",
    telefono2Recibe: "",
    telefono1Recibe: "",
    direccionRecibe: "",
    SectorRecibe: "",
    puebloRecibe: "",
    firma: "",
    valorEstimado: 0.00,
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    valorEstimado: 0.00,
    precio: 0.00,
    fecha: new Date
}


let options = [];
let options1 = [];
let Lineas = [];
let Total = 0;

const Venta = () => {
    const signatureRef = useRef({});
    const [firmaA, setfirmaA] = useState("");

    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [Listado, SetListado] = useState([]);
    const [ListadoNumeroUnico, SetListadoNumeroUnico] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [ListadoArticulos, SetListadoArticulos] = useState([]);
    const [ListadoClientes, SetListadoClientes] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [busqueda, setbusqueda] = useState("");

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
      
        var searchData = l.filter((item) => {
            if (
                (item.descripcion)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let correo = JSON.parse(user).correo;


    const handleChange = (e) => {
        if (e.target.name == "rnc" && e.target.value.length > 8) {
                ValidarRNC(e.target.value);
         }
        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }

    const ValidarRNC = async (x) => {
        let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, nombreCliente: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
            }
        }
    }

   
        const handleChange2 = (e) => {
            setTabla({
                ...tabla,
                ["clienteID"]: e.value, ["nombreCliente"]: e.nombre, ["iDEnvia"]: e.id, ["direccionEnvia"]: e.direccionEnvia,["telefono"]:e.telefono
            })
    }


    const handleChange3 = (e) => {
       
        setTabla1({

            pedidoLineaID:0, empresaID:1,pedidoID: tabla.pedidoID, numeroUnico: tabla.numeroUnico,
           orden:1 , articuloID: e.value, descripcionArticulo: e.nombre, almacenID: e.almacenID,
            cantidad: 1,costo:e.costo,precio:e.precio, fecha:new Date
        })
                                 
        }
         // GuardarLinea()  
    const GuardarLinea = async () => {
        let response = await fetch(Api + "VentasTrans/GuardarPedidoVentasLineas", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(tabla1)
        })
        if (response.ok) {
            obtenerDatosLineas(tabla.pedidoID);
            toast.success("Agregado")
        }
    }

    //Editar lineas
    const EditarLinea = async (x, valor, campo) => {
        
        if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        if (campo == 'cantidad') { x.cantidad = parseInt( valor); }
        if (campo == 'precio') { x.precio = valor; }
        if (campo == 'valorEstimado') { x.valorEstimado = valor; }



        let response = await fetch(Api + "VentasTrans/EditarPedidoVentasLineas", {
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(x)
        })
        if (response.ok) {
       
            toast.success("Agregado")
        }
    }
    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "VentasTrans/listaPedidoVentas");
        if (response.ok) {
            let data1 = await response.json();
            let data = data1.filter(x => x.estatus < 1).map(x => x);
            SetListado1(data)
            if (e == 1) {setPendiente(true) }
            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }

    /// mandar venta a caja para pago
    const EnviarCaja = async (p) => {
        Swal.fire({
            title: 'Enviar a Caja',
            text: "Estas seguro de que desea enviar a caja. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                tabla.firma = firmaA;
                let response = fetch(Api + "VentasTrans/EnviarCaja/" + p, {


                   method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })

                if (response.ok) {
                    let data =  response.json()
                    setTabla(modeloDatos);
                    setTabla1(modeloDatos1);
                }

                setVerModal(false);
                setPendiente(false);
                obtenerDatos(1);

            }
        })
     
    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "VentasTrans/ListaPedidoVentasLineas/"+pl);
        if (response.ok) {
            let data = await response.json()
                SetListadoLineas(data)
        }
    }

    const NumeroUnico = async () => {
        let response = await fetch(Api + "VentasMantenimiento/NumeroUnico");
        if (response.ok) {
            let data = await response.json()
            
            SetListadoNumeroUnico(data.filter(x => x.Pantalla =="Facturacion" && x.ID==1).map(x => x))
        }
    }


    const obtenerDatosArticulas = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos");

        if (response.ok) {
            let data = await response.json()
            SetListadoArticulos(data)
            data.filter(x => x.activo == true).map(x => {
                options1.push({
                    value: x.articuloID, label: x.articuloID + "-" + x.descripcion, nombre: x.descripcion,
                    almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                    , cambiarPrecio: x.cambiarPrecio
                })
            })
        }
    }

    const obtenerDatosClientes = async () => {
        let response = await fetch(Api + "Transporte/listaClientes");

        if (response.ok) {
            let data = await response.json()
            SetListadoClientes(data)
            data.map(x => {
                options.push({ value: x.clienteID, label: x.id + "-" + x.nombre + "-" + x.telefono, nombre: x.nombre, telefono:x.telefono ,id:x.id, direccionEnvia : x.direccion })
            })
        }
    }


    useEffect(() => {
        obtenerDatos();
        NumeroUnico();
    }, [])
    useEffect(() => {
        obtenerDatosArticulas();
        obtenerDatosClientes()
    }, [])

    //Guardar factura
    const guardarCambios = async () => {
        let response;
        if (tabla.pedidoID == 0) {

            response = await fetch(Api + "VentasTrans/GuardarPedidoVentas", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasTrans/EditarPedidoVentas", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            let data = await response.json()
            setPendiente(true)
            obtenerDatos();
            setTabla(data);
            obtenerDatosLineas(data.pedidoID);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            obtenerDatos()
        } else {
            alert("error al guardar")
        }

    }
    //Quitar lienas
    const quitarArticulo = async (id) => {
        let response = await fetch(Api + "VentasTrans/QuitarArticulo/" + id, { method: "DELETE" })
        if (response.ok) {
            toast.success("Proceso realizado")
            setPendiente(true)
            obtenerDatosLineas(tabla.pedidoID);
        }
    }

    //sumar secuencia numerica
    const Nuevo = async () => {
        let response = await fetch(Api + "VentasMantenimiento/SumNumeroUnico/1/Facturacion");
        if (response.ok) {
            let data = await response.json()
           tabla.numeroUnico = data;
            setVerModal(!verModal)

        }
      
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
        obtenerDatosLineas(data.pedidoID);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    //Lista de facturas
    const columns = [
        {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
        },
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
        },   {
            name: 'Fecha',
            selector: row => ( moment(row.fecha).format("DD/MM/YYYY") ),
            sortable: true,
        },

        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus >= 1} color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                </>
            ),
        },
    ];

    //Tabla lineas
const columns1 = [
        //{
        //    name: 'Orden',
        //    selector: row => row.articuloID,
        //    sortable: true,
        //},
      {
            name: 'Cantidad',
            selector: row => (<Input 
                type="number" value={row.cantidad } onChange={(e) => EditarLinea(row, e.target.value,'cantidad')} ></Input>),
            sortable: true,
        }  , {
            name: 'Descripcion',
            selector: row => (

                < Input value={row.descripcionArticulo} onChange={(e) => EditarLinea(row, e.target.value, 'descripcion')}></Input>),
            sortable: true,
        },{
            name: 'Precio',
            selector: row => (<Input type="number" onChange={(e) => EditarLinea(row, e.target.value, 'precio')} value={row.precio}></Input>),
            sortable: true,
        },{
            name: 'Total',
            selector: row => row.precio * row.cantidad,
            sortable: true,
    }, {
        name: 'Valor Estimado',
        selector: row => (<Input type="number" onChange={(e) => EditarLinea(row, e.target.value, 'valorEstimado')} value={row.valorEstimado}></Input>),
        sortable: true,
    },

    
        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={tabla.estatus>=1} size="sm" color="danger"
                        onClick={() => quitarArticulo(row.pedidoLineaID)}
                    >X</Button>
                </>
            ),
        },
    ];

    //Diseño tabla
    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>

        

              <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Pedidos
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>     <Button color="success" size="sm"
                        onClick={() => Nuevo()}
                    >Nuevo Pedido</Button>
                    </Col>
                        <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                       pagination
                        paginationComponentOptions={paginationComponentOptions}
                       customStyles={customStyles}
                    />
                </CardBody>
            </Card>
     
       
                    <Row>
                <Col md={6} style={{ border: "solid" }}>
                <b>ENVIA:</b>
                    <Row>
                        
                        <Col md={6}>
                            <FormGroup>

                                <Label>ClienteID</Label>
                                {/*<Input bsSize="sm" name="clienteID" onChange={handleChange} value={tabla.clienteID} />*/}

                                <Select
                                    name={"clienteID"}
                                    onChange={handleChange2}
                                    defaultValue={options.filter(x => x.value == tabla.clienteID)[0]}
                                    options={options}
                                />
                            </FormGroup>
                        </Col>           
                    
                           <Col md={6} >
                            <FormGroup>

                        <Label>ID o Licencia</Label>
                                <Input disabled={tabla.clienteID != 1} bsSize="sm" name="iDEnvia" onChange={handleChange} value={tabla.iDEnvia} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>Nombre Cliente</Label>
                                <Input disabled={tabla.clienteID != 1} bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                            </FormGroup></Col>

                <Col md={6} >
                    <FormGroup>

                        <Label>Telefono</Label>
                        <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} />
                            </FormGroup></Col>
                        <Col md={12} >
                            <FormGroup>

                                <Label>Direccion </Label>
                                <Input bsSize="sm" type="textarea" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Sector</Label>
                                <Input bsSize="sm" name="sectorEnvia" onChange={handleChange} value={tabla.sectorEnvia} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Pueblo</Label>
                                <Input bsSize="sm" name="puebloEnvia" onChange={handleChange} value={tabla.puebloEnvia} />
                            </FormGroup></Col>
            </Row>
            </Col>
                <Col md={6} style={{ border: "solid" }}>
                    <b>RECIBE:</b>
                    <Row>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Fecha</Label>
                                <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(tabla.fecha).format('YYYY-MM-DD')} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>ID o Licencia Recibe</Label>
                                <Input bsSize="sm" name="iDRecibe" onChange={handleChange} value={tabla.iDRecibe} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Nombre Persona</Label>
                                <Input bsSize="sm" name="nombreRecibe" onChange={handleChange} value={tabla.nombreRecibe} />
                            </FormGroup></Col>
                      
                        <Col md={6} >
                            <FormGroup>

                                <Label>Telefono 1</Label>
                                <Input bsSize="sm" name="telefono1Recibe" onChange={handleChange} value={tabla.telefono1Recibe} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Telefono 2</Label>
                                <Input bsSize="sm" name="telefono2Recibe" onChange={handleChange} value={tabla.telefono2Recibe} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Direccion</Label>
                                <Input bsSize="sm" type="textarea" name="direccionRecibe" onChange={handleChange} value={tabla.direccionRecibe} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Sector</Label>
                                <Input bsSize="sm" name="sectorRecibe" onChange={handleChange} value={tabla.sectorRecibe} />
                            </FormGroup></Col>
                        <Col md={6} >
                            <FormGroup>

                                <Label>Pueblo</Label>
                                <Input bsSize="sm" name="puebloRecibe" onChange={handleChange} value={tabla.puebloRecibe} />
                            </FormGroup></Col>
                       

               



                <Button hidden={tabla.pedidoID != 0} size="sm" color="primary"
                    onClick={guardarCambios}
                >Continuar con el proceso</Button>
                </Row>
                </Col>
            </Row>
                    <br />
                    <div hidden={tabla.pedidoID == 0 }>
                    <Row>
                        <Col md={1.5} >
                        <Label>Articulo</Label>
                        </Col>
                        <Col md={8} >
                        <Select
                            name={"articuloID"}
                            onChange={handleChange3}
                            options={options1}
                            /></Col>
                            <Col md={2} >
                        <Button size="sm" color="primary"
                            onClick={GuardarLinea}
                        >Add</Button>
  </Col>
                    </Row>

         

                        <Row>
                            <DataTable
                                columns={columns1}
                                data={ListadoLineas}
                                //progressPending={pendiente1}
                              //  pagination
                            //    paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                            />
                                        </Row>
                    </div>
             
                    <Button hidden={tabla.pedidoID != 0 && tabla.estatus == 1} size="sm" color="primary"
                        onClick={()=>setVerModal(true)}
                    >Cobrar Factura</Button>   

                 
             


            <Modal isOpen={verModal} className="modal-preguntas" >
                <ModalHeader className="modal-header1">
                    Cobrando a: {tabla.nombreCliente}
                </ModalHeader>
                <ModalBody>
                    {Total}

                    <Fragment>
                        <SignatureCanvas
                            canvasProps={{
                                width: "800", height: 300,
                                style: { "border": "1px solid #000000" }
                            }}
                            minWidth={2}
                            maxWidth={3}

                            ref={signatureRef}
                            onEnd={() => (
                               setfirmaA(signatureRef.current.getTrimmedCanvas().toDataURL("image/jpg"))
                            )}
                        />
                    </Fragment>
                    {/*<Col md={3} >*/}
                    {/*    <FormGroup>*/}

                    {/*        <Label>Efetivo</Label>*/}
                    {/*        <Input bsSize="sm" type="number" name="efectivo" onChange={handleChange} value={tabla2.efectivo} />*/}
                    {/*    </FormGroup></Col>*/}
                    {/*<Col md={3} >*/}
                    {/*    <FormGroup>*/}

                    {/*        <Label>Tarjeta</Label>*/}
                    {/*        <Input bsSize="sm" type="number" name="tarjeta" onChange={handleChange} value={tabla2.tarjeta} />*/}
                    {/*    </FormGroup></Col>*/}
                    {/*<Col md={3} >*/}
                    {/*    <FormGroup>*/}

                    {/*        <Label>Transferencia</Label>*/}
                    {/*        <Input bsSize="sm" type="number" name="transferencia" onChange={handleChange} value={tabla2.transferencia} />*/}
                    {/*    </FormGroup></Col>*/}
                    {/*<Col md={3} >*/}
                    {/*    <FormGroup>*/}

                    {/*        <Label>Cheque</Label>*/}
                    {/*        <Input bsSize="sm" name="cheque" onChange={handleChange} value={tabla2.cheque} />*/}
                    {/*    </FormGroup></Col>*/}
                    {/*Devuelta: {(parseFloat(tabla2.efectivo) + parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia) + parseFloat(tabla2.cheque)) - Total}*/}
                </ModalBody>
                <ModalFooter>



                    {/*<Button hidden={tabla.facturado} size="sm" color="success"*/}
                    {/*    onClick={() => ProcesarPago()}*/}

                    {/*>Pagar {tabla.facturado}</Button>*/}
                    <Button hidden={tabla.pedidoID != 0 && tabla.estatus == 1} size="sm" color="primary"
                        onClick={() => EnviarCaja(tabla.pedidoID)}
                    >Cobrar Factura</Button>   
                    <Button size="sm" color="danger"
                        onClick={() => setVerModal(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            <img src={firmaA } / >
          
            


        </>
    )

}
export default Venta;